export default __webpack_public_path__ + "static/4-89f755b22f37dcbb87e457ed039262eb.webp";